export enum SA_ENTITY_TYPE {
  GROUP = 'group',
  EVENT = 'event',
}
